import React from 'react';
import {
  Box,
  HStack,
  Heading,
  Text,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  backTo?: string;
  onBack?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  showBackButton = true,
  backTo = '/',
  onBack,
}) => {
  const navigate = useNavigate();
  const textColor = useColorModeValue('gray.800', 'white');
  const subtitleColor = useColorModeValue('gray.600', 'gray.400');

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backTo);
    }
  };

  return (
    <Box 
      mb={4} 
      h={{ base: "60px", lg: "auto" }}
      display="flex"
      alignItems="center"
    >
      <HStack justify="space-between" align="center" w="full">
        <HStack spacing={3}>
          {/* 返回按钮 - 移动端显示 */}
          {showBackButton && (
            <IconButton
              icon={<FiArrowLeft />}
              variant="ghost"
              onClick={handleBack}
              aria-label="返回"
              display={{ base: "flex", lg: "none" }}
              size="sm"
            />
          )}
          
          {/* 标题区域 - 移动端显示 */}
          <Box display={{ base: "block", lg: "none" }}>
            <Heading size="lg" color={textColor}>
              {title}
            </Heading>
            {subtitle && (
              <Text color={subtitleColor} fontSize="sm" mt={1}>
                {subtitle}
              </Text>
            )}
          </Box>
        </HStack>
      </HStack>
    </Box>
  );
};

export default PageHeader; 